//! @ngInject
export function newVisitSuggestedCaregiversModalCtrl($scope, $uibModalInstance, NgTableParams, toaster, $filter) {
    const NO_DISTANCE_FILTER_MILES = 100;
    const searchCaregiverList = $scope.$resolve.searchCaregiverList;
    const searchCaregiverResults = $scope.$resolve.searchCaregiverResults;
    $scope.searchResultsOnly = typeof searchCaregiverResults === "function";
    let loadedSearchTerm = null;
    const serverBacked = typeof searchCaregiverList === "function";
    let latestRequest = 0;
    let destroyed = false;
    $scope.$on('$destroy', () => { destroyed = true; latestRequest++; });

    $scope.suggestedCaregiversGlobalFilter = { val: "" };
    $scope.allCaregivers = $scope.$resolve.caregivers || [];
    $scope.maxDistanceMiles = NO_DISTANCE_FILTER_MILES;
    $scope.noDistanceFilterMiles = NO_DISTANCE_FILTER_MILES;

    const init = () => {
        initSuggestedCaregiversTable();
    };

    const applyFilters = () => {
        const searchTerm = ($scope.suggestedCaregiversGlobalFilter.val || "").toLowerCase();
        const maxMi = Number($scope.maxDistanceMiles);

        return $scope.allCaregivers.filter((c) => {
            if (maxMi < NO_DISTANCE_FILTER_MILES) {
                if (c.distanceFromHomeInMiles == null) return false;
                if (c.distanceFromHomeInMiles > maxMi) return false;
            }
            if (searchTerm && !$scope.searchResultsOnly) {
                const hay = [
                    c.displayName || "",
                    c.employmentType || "",
                ].join(" ").toLowerCase();
                if (!hay.includes(searchTerm)) return false;
            }
            return true;
        });
    };

    const initSuggestedCaregiversTable = () => {
        $scope.suggestedCaregiversTable = new NgTableParams(
            { count: serverBacked ? 5 : 10 },
            {
                ...(serverBacked ? { counts: [] } : {}),
                getData: async (params) => {
                    if (serverBacked) {
                        const sequence = ++latestRequest;
                        const order = params.orderBy()[0] || '+displayName';
                        $scope.loading = true;
                        $scope.loadError = false;
                        return searchCaregiverList({
                            search: $scope.suggestedCaregiversGlobalFilter.val || '',
                            maxDistanceMiles: Number($scope.maxDistanceMiles) < NO_DISTANCE_FILTER_MILES
                                ? Number($scope.maxDistanceMiles) : null,
                            offset: (params.page() - 1) * 5,
                            sortField: order.replace(/^[+-]/, ''),
                            sortOrder: order.startsWith('-') ? 'desc' : 'asc'
                        }).then((page) => {
                            if (destroyed || sequence !== latestRequest) return $scope.currentPage || [];
                            $scope.loading = false;
                            params.total(page.totalCount);
                            $scope.currentPage = page.items;
                            return page.items;
                        }, () => {
                            if (destroyed || sequence !== latestRequest) return $scope.currentPage || [];
                            $scope.loading = false;
                            $scope.loadError = true;
                            params.total(0);
                            $scope.currentPage = [];
                            return [];
                        });
                    }
                    if ($scope.searchResultsOnly) {
                        const term = $scope.suggestedCaregiversGlobalFilter.val.trim();
                        const sequence = ++latestRequest;
                        if (term !== loadedSearchTerm) {
                            $scope.loading = true;
                            $scope.loadError = false;
                            try {
                                const results = term ? await searchCaregiverResults(term) : [];
                                if (destroyed || sequence !== latestRequest) return [];
                                $scope.allCaregivers = results;
                                loadedSearchTerm = term;
                            } catch (_error) {
                                if (destroyed || sequence !== latestRequest) return [];
                                $scope.allCaregivers = [];
                                loadedSearchTerm = null;
                                $scope.loadError = true;
                            }
                        }
                        $scope.loading = false;
                    }
                    let data = applyFilters();
                    const orderBy = params.orderBy();
                    if (orderBy.length) {
                        data = $filter("orderBy")(data, orderBy);
                    }
                    params.total(data.length);
                    return data.slice(
                        (params.page() - 1) * params.count(),
                        params.page() * params.count()
                    );
                },
            }
        );
    };

    $scope.applysuggestedCaregiversGlobalSearch = () => {
        if ($scope.suggestedCaregiversTable) {
            $scope.suggestedCaregiversTable.page(1);
            $scope.suggestedCaregiversTable.reload();
        }
    };

    $scope.applyDistanceFilter = () => {
        if ($scope.suggestedCaregiversTable) {
            $scope.suggestedCaregiversTable.page(1);
            $scope.suggestedCaregiversTable.reload();
        }
    };

    $scope.handleSelect = (selectedCaregiver) => {
        if (!selectedCaregiver || !selectedCaregiver.id) {
            return toaster.pop("error", "Something went wrnog", "Chosen caregiver is invalid");
        }
        $scope.$resolve.handleCaregiverSelect(selectedCaregiver);
        $scope.closeModal();
    };

    $scope.closeModal = function () {
        $uibModalInstance.close();
    };

    init();
}
